<template>
  <div v-if="(!errorMsg && !isLoading) || isDev" id="app">
    <!-- <AppHeader></AppHeader> -->
    <div class="wrapper">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
    <AppFooter></AppFooter>
  </div>
  <teleport to="body">
    <LoadingScreen v-if="!isDev" :isLoading="isLoading" :errorMsg="errorMsg" />
    <UiToastList />
    <UiModal />
  </teleport>
</template>

<script>
import AppHeader from "./Header.vue";
import AppFooter from "./Footer.vue";
import { PurlService } from "@/services/purl.service";
import { CmsService } from "@/services/cms.service";
import UiToastList from "@/components/UiToastList";
import UiModal from "@/components/UiModal";
import LoadingScreen from "@/components/LoadingScreen";

export default {
  name: "AppLayout",
  components: {
    AppHeader,
    AppFooter,
    UiToastList,
    UiModal,
    LoadingScreen,
  },
  data() {
    return {
      fetchParams: null,
      isLoading: true,
      errorMsg: "",
      routeName: this.$router.currentRoute,
      isDev: process.env.NODE_ENV === "development",
    };
  },
  methods: {
    fetchData() {
      this.isLoading = true;

      //* Initial cms fetch
      CmsService.getCms()
        .then((cms) => {
          // console.log("cms", cms);
          this.$store.dispatch("purl/setCmsInfo", cms?.entries);
          return cms?.entries;
        })
        .catch((e) => {
          console.log("Error: ", e.message);
          this.errorMsg = e.message;
        })
        .then((cms) => {
          PurlService.getPurl(this.purlId, cms)
            .then(({ purl }) => {
              this.$store.dispatch("purl/setPurlInfo", purl);
            })
            .catch((e) => {
              console.log("Error: ", e.message);
              if (e.message === "Purl not found.") {
                this.errorMsg = e.message;
              } else {
                this.errorMsg = "Server error: please try again later.";
              }
            })
            .finally(() => {
              setTimeout(() => {
                this.isLoading = false;
              }, 2000);
            });
        });
    },
  },
  computed: {
    purlId() {
      return this.$store.state.purl.id;
    },
  },
  watch: {
    purlId: function () {
      this.fetchData();
    },
  },
  beforeUnmount: () => {
    window.removeEventListener("resize", () =>
      this.$store.commit("dom/SET_WINDOW_WIDTH", window.innerWidth)
    );
  },
};
</script>
<style lang="scss">
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
</style>
